import {TemplateResult, html} from "lit";

export abstract class Step {
  renderStep(): TemplateResult {
    return html`
      <div slot="title">
        ${this.renderTitle()}
      </div>
      ${this.renderContent()}
      <div slot="footer">
        ${this.renderFooter()}
      </div>
    `;
  }

  protected abstract renderTitle(): TemplateResult;

  protected abstract renderContent(): TemplateResult;

  protected abstract renderFooter(): TemplateResult;
}
